<template>
    <v-dialog persistent width="450" v-model="isPopup">
        <div class="filesWrapper">
            <div class="popupHead">Add invoice
                <button type="button" @click="onClose">
                    <svg-sprite width="20" height="20" icon-id="close"></svg-sprite>
                </button>
            </div>
            <div class="filesWrapper_title">Invoice info</div>
            <div class="groupField_wrap">
                <field
                    :class-error="$v.fileItem.invoice.$error"
                    margin="0"
                    width="410px"
                    label="Invoice#"
                    placeholder="Input invoice"
                    :setInputValue="fileItem.invoice"
                    @updateInput="onInput($event, 'invoice')"
                    is-required
                ></field>
            </div>
            <div class="groupField_wrap">
                <field
                    margin="0 10px 0 0"
                    width="200px"
                    label="Labor"
                    type="number"
                    placeholder="Input labor"
                    :setInputValue="fileItem.labor"
                    icon="dollar"
                    @updateInput="onInput($event, 'labor', 1)"
                ></field>
                <field
                    margin="0"
                    width="200px"
                    label="Parts"
                    type="number"
                    icon="dollar"
                    placeholder="Input parts"
                    :setInputValue="fileItem.parts"
                    @updateInput="onInput($event, 'parts', 1)"
                ></field>
            </div>
            <div class="groupField_wrap">
                <field
                    margin="0"
                    width="410px"
                    label="Total"
                    icon="dollar"
                    placeholder="-"
                    :setInputValue="fileItem.total"
                    is-disabled
                ></field>
            </div>
            <div class="groupField_wrap">
                <field
                    margin="0"
                    width="410px"
                    label="File"
                    placeholder="Add file"
                    :setInputValue="fileItem['file_name']"
                    @updateFile="setNewItem($event)"
                    @updateView="onView"
                    is-file
                    color-icon="#19BC38"
                    :is-file-icon="!!fileItem['file_name']"
                    is-readonly
                ></field>
            </div>
            <button-groups @updateBtnClose="onClose" @updateSave="onSave"></button-groups>
        </div>
    </v-dialog>
</template>

<script>
import ButtonGroups from "@/shared/ButtonGroups/ButtonGroups";
// validations
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
// helper
import getDefaultDate from "@/helper/getDefaultDate";
import { formatCurrency } from "@/helper";

export default {
	name: "InvoicePopup",
	mixins: [ validationMixin ],
	components: {
		ButtonGroups
	},
	props: {
		fileType: Array,
		createBy: String
	},
	data: (v) => ({
		isPopup: true,
		downloadLink: '',
		fileItem: {
			create_at: null,
			created_by: v.createBy,
			labor: null,
			parts: null,
			total: null,
			invoice: null
		}
	}),
	validations: {
		fileItem: {
			invoice: { required }
		}
	},
	methods: {
		getTotal() {
			const { labor, parts } = this.fileItem;
			const total = (+labor) + (+parts);

			this.$set(this.fileItem, 'total', +formatCurrency(total));
		},
		onClose() {
			this.$emit('updateClose');
		},
		onAutocomplete({ value }) {
			this.$set(this.fileItem, 'category_id', value.id);
		},
		setNewItem(e) {
			const iFile = e.target.files[0];
			const reader = new FileReader();

			reader.readAsDataURL(iFile);
			reader.onload = () => {
				this.$set(this.fileItem, 'file_name', iFile.name);
				this.$set(this.fileItem, 'file', reader.result);
				this.fileItem.create_at = getDefaultDate();
			};
		},
		onSave() {
			this.$v.$touch();
			if (!this.$v.$error) {
				this.$emit('updateFilesList', this.fileItem);
				this.onClose();
			}
		},
		onInput({ value }, key, isNumber) {
			this.$set(this.fileItem, key, isNumber ? +value : value);
			this.getTotal();
		},
		onView() {
			const { file } = this.fileItem;
			this.$emit('updateView', file);
		}
	}
};
</script>

<style scoped lang="scss">
	@import "invoicePopup"
</style>
